<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {getMonthFirstToLastDate} from '@qx/utils';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        dealResultOptions: [],
        form: [
          {
            label: '选择处理月份',
            value: 'dealDate',
            type: 'date',
            default: getMonthFirstToLastDate()[0],
            attr: {
              type: 'month',
            },
          },
          {
            label: '处理结果',
            value: 'dealResult',
            type: 'select',
            default: -1,
            placeholder: '请选择处理结果',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      searchBoxData.dealDate = this.formatDate(searchBoxData.dealDate, 3);
      searchBoxData.dealResult = searchBoxData.dealResult === -1 ? '' : searchBoxData.dealResult;
      searchBoxData.tenantId = this.userInfo.staffTFInfo.tenantId,
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'DEAL_RESULT',
    });
    this.searchBoxData.dealResultOptions = [
      {label: '全部', value: -1},
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
